import { FactoryProvider } from '@angular/core';
import { TranslationService } from '@lib/i18n/data-access';
import {
  DropdownOption,
  PAGE_SIZE_SELECTOR_CONFIG_TOKEN,
  PageSizeSelectorConfig,
  PAGINATION_BAR_CONFIG_TOKEN,
  PaginationBarConfig,
} from '@platform-workspace/design-system';

export const providePaginationBarConfig = (): FactoryProvider => {
  return {
    provide: PAGINATION_BAR_CONFIG_TOKEN,
    useFactory: (translationService: TranslationService): PaginationBarConfig => ({
      exportLabel: translationService.translate('common.Export:'),
    }),
    deps: [TranslationService],
  };
};

export const providePageSizeSelectorConfig = (): FactoryProvider => {
  return {
    provide: PAGE_SIZE_SELECTOR_CONFIG_TOKEN,
    useFactory: (translationService: TranslationService): PageSizeSelectorConfig => ({
      mapToOptions(sizes: number[]): DropdownOption[] {
        return sizes.map((size) => ({
          text: translationService.translate('common.Per Page', { size }),
          value: size,
        }));
      },
    }),
    deps: [TranslationService],
  };
};
